import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=51c079a0&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableText.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EditableText.vue?vue&type=style&index=0&id=51c079a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c079a0",
  null
  
)

export default component.exports